import Vue from "vue";
import Router from "vue-router";
import External from "@/components/master/External";
import Internal from "@/components/master/Internal";
import CardView from "@/components/master/CardView";

const Home = () => import("@/components/pages/Home");
const DocScan = () => import("@/components/pages/DocScan");
const Success = () => import("@/components/pages/Success");
const Resume = () => import("@/components/pages/Resume");
const NotFound = () => import("@/components/pages/NotFound");
const zPayNewPassword = () => import("@/components/pages/zPayNewPassword");
import find from "lodash/find";

import Store from "../store";

import { ReservationService } from "smck-service";
import StrategyManager from "@/strategies/manager";
import CompanyService from "@/service/company-service";

// Novo Fluxo
const SearchScene = () => import("@/components/pages/NovoFluxo/Search");
const CheckInDisabled = () =>
  import("@/components/pages/NovoFluxo/CheckInDisabled");
const MultReservationScene = () =>
  import("@/components/pages/NovoFluxo/MultReservation");
const MultGuestsScene = () => import("@/components/pages/NovoFluxo/MultGuests");
const WhatsAppOptIn = () => import("@/components/pages/WhatsAppOptIn");

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  linkActiveClass: "is-active",
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      name: "external",
      component: External,
      children: [
        {
          path: "/resume/:fnrhId",
          name: "Resume",
          component: Resume
        },
        {
          path: "/conclusion/:reservationId",
          name: "ResumeChoose",
          component: Success
        },
        {
          path: "/conclusion",
          name: "Success",
          component: Success
        },
        {
          path: "/whatsapp-optin",
          name: "WhatsAppOptIn",
          component: WhatsAppOptIn
        },
        {
          path: "/checkout/:reservationNumber?",
          name: "Checkout",
          beforeEnter: async to => {
            const companyService = new CompanyService();
            const reservationService = new ReservationService();
            const strategyManager = new StrategyManager();
            await strategyManager.setStrategy(0); // GuestControl strategy
            const reservationNumber = to.params.reservationNumber;
            const company = await companyService.getLocalCompany();

            if (reservationNumber) {
              const reservations = await reservationService.getAll(
                company.id,
                reservationNumber
              );

              if (reservations && reservations.data.length > 0) {
                const reservation = reservations.data[0];
                const guest = reservation.guests.find(g => g.masterGuest);

                await strategyManager.redirect(reservation, guest);
              } else {
                await strategyManager.redirectWalkIn(company.id);
              }
            } else {
              await strategyManager.redirectWalkIn(company.id);
            }
          }
        },
        {
          path: "/document-scan/:reservationId/:guestId",
          name: "DocScan",
          component: DocScan
        },
        {
          path: "/",
          name: "CardView",
          component: CardView,
          children: [
            {
              path: "/",
              name: "Search",
              component: SearchScene
            },
            {
              path: "/validate/pin/:hash",
              name: "ValidatePin",
              component: SearchScene
            },
            {
              path: "/checkindisabled",
              name: "CheckInDisabled",
              component: CheckInDisabled
            },
            {
              path: "/multr",
              name: "MultReservation",
              component: MultReservationScene
            },
            {
              path: "/:reservationId/:guestId",
              name: "MultGuest",
              component: MultGuestsScene
            },
            {
              path: "/zpay-new-password/:reservationId/:guestId",
              name: "zPayNewPassword",
              component: zPayNewPassword
            }
          ]
        },
        {
          path: "/notfound",
          name: "NotFound",
          component: NotFound
        }
      ]
    },
    {
      path: "/",
      name: "internal",
      component: Internal,
      children: [
        {
          path: "guest/:reservationId/:guestId",
          name: "Home",
          component: Home
        }
      ]
    }
    // {
    //   path: "/camera-debug",
    //   name: "internal",
    //   component: () => import("@/components/pages/CameraDebug")
    // }
  ]
});

const beforeEnter = async (to, from, next) => {
  const reservationService = new ReservationService(Vue);

  let reservation = reservationService.getLocalReservation();
  const company = localStorage.getItem("currentCompany");

  const companyParams = JSON.parse(company).parameters_sc.operation_flow;
  const enableRedirect = companyParams && companyParams.enableRedirect;
  const origin = to.query.origin || "zooxpass";

  if (
    to.params.reservationId === "legacy" &&
    to.params.guestId === "checkout"
  ) {
    const companyParsedData = JSON.parse(company);
    const strategyManager = new StrategyManager();
    await strategyManager.setStrategy(0); // GuestControl strategy
    await strategyManager.redirectWalkIn(companyParsedData.id);
    return;
  }

  if (
    to.params.reservationId != null &&
    reservation.id !== to.params.reservationId
  ) {
    if (to.params.reservationId === "undefined") {
      const result = await reservationService.getOneByGuestIdFromNewPass(
        to.params.guestId
      );
      const reservationId = result._id;

      window.location.href = window.location.href.replace(
        /\/undefined\//,
        `/${reservationId}/`
      );
      return;
    } else {
      reservation = await reservationService.getOne(to.params.reservationId);
      reservationService.setLocalReservation(reservation);
    }
  }

  let guest = null;

  if (to.query.docScanToken) {
    next();
    return;
  }

  if (to.params.guestId) {
    guest = find(reservation.guests, item => {
      return item.id === to.params.guestId;
    });

    const unfinalizedGuests = reservation.guests.filter(g => !g.fnrhId);

    if (
      guest &&
      guest.fnrhId &&
      !(guest.masterGuest && unfinalizedGuests.length > 0)
    ) {
      if (enableRedirect) {
        return redirectTo(reservation, guest, companyParams.redirectTo);
      }
    }
  }

  if (to.params.reservationId && to.name !== "MultGuest") {
    try {
      // verificar se a reserva ja foi preenchida
      if (to.params.guestId) {
        guest = find(reservation.guests, item => {
          return item.id === to.params.guestId;
        });
        const unfinalizedGuests = reservation.guests.filter(g => !g.fnrhId);
        if (
          guest &&
          guest.fnrhId &&
          !(guest.masterGuest && unfinalizedGuests.length > 0) &&
          !to.query.docScanToken
        ) {
          if (enableRedirect) {
            return redirectTo(reservation, guest, companyParams.redirectTo);
          } else {
            const masterGuest = reservation.guests.find(g => g.masterGuest);
            if (
              guest.completedSteps.dataConfirmation &&
              to.name === "Home" &&
              masterGuest.isFinalized == null
            ) {
              Store.dispatch("$setCurrentMobileStep", 4);
              next();
            } else {
              next(`/resume/${guest.fnrhId}`);
            }
          }
        } else {
          guest = find(reservation.guests, item => {
            return item.id === to.params.guestId;
          });

          const unfinalizedGuests = reservation.guests.filter(g => !g.fnrhId);
          const finalizedGuests = reservation.guests.filter(g => g.fnrhId);

          if (enableRedirect && unfinalizedGuests.length <= 0) {
            return redirectTo(reservation, guest, companyParams.redirectTo);
          } else if (unfinalizedGuests.length > 0) {
            const selectedGuest = localStorage.getItem("selectedGuestId");
            const FromMultguest = localStorage.getItem("cameFromMultGuest");
            if (finalizedGuests.length > 0) {
              if (selectedGuest && selectedGuest === guest.id) {
                Store.dispatch("$setCurrentMobileStep", 1);
                next();
              } else {
                Store.dispatch("$setCurrentReservation", reservation);

                if (FromMultguest && FromMultguest === "true") {
                  Store.dispatch("$setCurrentMobileStep", 1);
                  next();
                  localStorage.removeItem("cameFromMultGuest");
                } else {
                  Store.dispatch("$setCurrentMobileStep", 0);
                  next(`/${reservation.id}/${guest.id}`);
                }
              }
            } else {
              Store.dispatch("$setCurrentMobileStep", 1);
              next();
            }
          } else {
            next(`/resume/${guest.fnrhId}`);
          }
        }
      } else {
        const guestsNotFinalized = reservation.guests.filter(item => {
          return !item.fnrhId;
        });
        if (guestsNotFinalized.length === 0) {
          guest = find(reservation.guests, item => {
            return item.masterGuest === true;
          });

          if (guest && guest.fnrhId && !to.query.docScanToken) {
            if (enableRedirect) {
              return redirectTo(reservation, guest, companyParams.redirectTo);
            } else {
              if (
                guest.completedSteps.dataConfirmation === true &&
                to.name === "Home"
              ) {
                Store.dispatch("$setCurrentMobileStep", 4);
                next(`/guest/${reservation.id}/${guest.id}`);
              } else {
                next(`/resume/${guest.fnrhId}`);
              }
            }
          }
        }
      }

      next();
    } catch (error) {
      if (error && error.status === 404) {
        next("notfound");
      }
    }
  } else if (
    from.name === null &&
    to.name === "Search" &&
    reservation.id &&
    origin === "zooxpass"
  ) {
    const guestsNotFinalized = reservation.guests.filter(item => {
      return !item.fnrhId;
    });
    if (guestsNotFinalized.length === 0) {
      const guest = find(reservation.guests, item => {
        return item.masterGuest === true;
      });

      if (guest && guest.fnrhId) {
        if (enableRedirect) {
          return redirectTo(reservation, guest, companyParams.redirectTo);
        } else {
          if (
            guest.completedSteps.dataConfirmation === true &&
            to.name === "Home"
          ) {
            Store.dispatch("$setCurrentMobileStep", 4);
            next(`/guest/${reservation.id}/${guest.id}`);
          } else {
            next(`/resume/${guest.fnrhId}`);
          }
        }
      }
    } else {
      next();
    }
  } else {
    // se user estiver na tela de sucesso e clicar no back-button
    // redireciona-lo para a tela inicial de busca
    if (from.name === "Success") {
      next("/");
    } else {
      next();
    }
  }
};

const afterEach = async (to, from, next) => {
  if (to.name === "MultGuest") {
    const reservationService = new ReservationService(Vue);
    const company = localStorage.getItem("currentCompany");
    const companyParams = JSON.parse(company).parameters_sc.operation_flow;
    const enableRedirect = companyParams && companyParams.enableRedirect;
    const reservation = reservationService.getLocalReservation();
    if (reservation.guests.length > 0) {
      try {
        if (to.params.guestId) {
          const guestsNotFinalized = reservation.guests.filter(item => {
            return !item.fnrhId;
          });
          if (guestsNotFinalized.length === 0) {
            const guest = find(reservation.guests, item => {
              return item.masterGuest === true;
            });
            if (guest && guest.fnrhId) {
              if (enableRedirect) {
                return redirectTo(reservation, guest, companyParams.redirectTo);
              } else if (guest.fnrhId && guest.isFinalized === true) {
                router.push(`/resume/${guest.fnrhId}`);
              } else {
                const metadataExpirationRaw = localStorage.getItem(
                  "metadata-timeout-expiredPin"
                );

                const expirationData =
                  metadataExpirationRaw != null
                    ? JSON.parse(metadataExpirationRaw)
                    : null;

                if (expirationData == null) {
                  router.push(`/resume/${guest.fnrhId}`);
                }
              }
            }
          } else {
            Store.dispatch("$setCurrentMobileStep", 1);

            next();
          }
        }
      } catch (err) {
        if (err && err.status === 404) {
          router.push("notfound");
        }
      }
    }
  }
};

router.beforeEach(beforeEnter);
router.afterEach(afterEach);

async function redirectTo(reservation, guest, strategy) {
  const strategyManager = new StrategyManager();
  await strategyManager.setStrategy(strategy);
  await strategyManager.redirect(reservation, guest);
}

export default router;
